import { getNestedProperty } from "./get-nested-property.js";
import { isPlainObject } from "./type-guards.js";
const getLocalizedValue = (attribute, locale) => {
  if (!isPlainObject(attribute)) {
    return "";
  }
  const language = locale.substr(0, 2);
  let attr = attribute;
  if (attribute.hasOwnProperty("key") && attribute.hasOwnProperty("label")) {
    const obj = attribute;
    attr = obj?.label;
  }
  const result = attr[locale] || attr[language] || getNestedProperty(attr, "en") || "";
  if (isPlainObject(result)) {
    return "";
  }
  return result;
};
const getLocalizedValues = (attributes, locale) => {
  if (!Array.isArray(attributes)) {
    return [];
  }
  return attributes.map((attr) => getLocalizedValue(attr, locale));
};
export {
  getLocalizedValue,
  getLocalizedValues
};
//# sourceMappingURL=get-localized-value.js.map
